export default __webpack_public_path__ + "static/media/icdlquestionbank.0008b90e.svg";